import React from 'react';
import PropTypes from 'prop-types';
import { wrapperStyle, contentStyle, titleStyle, bodyStyle, imageStyle } from './styles';

export class ComingSoon extends React.Component {
	static propTypes = {
		image: PropTypes.string,
		imageWidth: PropTypes.number,
		title: PropTypes.string,
		body: PropTypes.string,
		background: PropTypes.string,
	};

	render() {
		const { image, imageWidth, title, body, background } = this.props;
		return (
			<div className={wrapperStyle(background)}>
				<img src={image} alt="" width={imageWidth} className={imageStyle} />
				<div className={contentStyle}>
					<p className={titleStyle}>{title}</p>
					<p className={bodyStyle}>{body}</p>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/shared/comingSoon/component.js